import React, { useState } from "react";
import { Link } from "react-router-dom";

// import ss1 from "../../dbt_assets/images/visualize-result-set.gif";
// import ss2 from "../../dbt_assets/images/2.gif";
// import ss5 from "../../dbt_assets/images/3.gif";
// import ss4 from "../../dbt_assets/images/4.gif";

import demo_1_1 from "../../assets/images/gifs/extension_gifs/1-1-sql-to-dbt-models.gif";
import demo_1_2 from "../../assets/images/gifs/extension_gifs/1-2-update-dbt-mode.gif";
// import demo_2_1a2 from "../../assets/images/gifs/extension_gifs/2-1_2-autocomplete.gif";
// import demo_2_3 from "../../assets/images/gifs/extension_gifs/2-3-runmodeltests.gif";
import demo_2 from "../../assets/images/gifs/extension_gifs/2-documentaton.gif";
import demo_3_1 from "../../assets/images/gifs/extension_gifs/3-1-generate_tests.gif";
import demo_3_2 from "../../assets/images/gifs/extension_gifs/3-2-query_explanation.gif";
import demo_3_3 from "../../assets/images/gifs/extension_gifs/3-3-lineage.gif";
import demo_4 from "../../assets/images/gifs/extension_gifs/4-bestpractices.gif";
// import demo_4_1 from "../../assets/images/gifs/extension_gifs/4-1-gendoc.gif";
// import demo_4_2 from "../../assets/images/gifs/extension_gifs/4-2_3-previewquery.gif";
// import demo_5_1 from "../../assets/images/gifs/extension_gifs/5-1-sqlValidation.gif";
// import demo_5_2a3 from "../../assets/images/gifs/extension_gifs/5-2_3-project_health_check.gif";

import checkMark from "../../assets/images/svgs/check-mark.svg";
import { DBT_NAME } from "../../constant";

// create a component for the div we are rendering while looping through the dbtFeatureColumns array
const DBTFeaturesColumns = ({ id, reversed, title, points }) => {
  const [showGif, setShowGif] = useState(0);
  console.log(title);

  return (
    <div
      id={id}
      className={`w-full h-full flex md:flex-row flex-col items-center justify-center md:mt-[140px] md:gap-[60px] ${
        reversed ? "md:flex-row-reverse" : "md:flex-row"
      }`}
    >
      <div
        className={`md:h-auto md:min-w-[520px] md:max-w-[521px] md:text-left text-center`}
      >
        <h2 className="lexend text-[#082247] md md:text-[30px] text-2xl font-bold md:mt-0 mt-[44px] mb-[10px] leading-[39px]">
          {title}
        </h2>
        <div className="flex flex-col mt-10 md:px-0 px-[5%]">
          {points.map((point, idx) => (
            <div
              key={idx}
              onClick={(e) => {
                e.stopPropagation();
                setShowGif(idx);
              }}
              className={`hover:bg-[#FFFFFF] min-h-[58px] flex justify-start items-start border border-[#dadee3ca] rounded-[10px] p-[16px] mb-5 cursor-pointer gap-[8px] ${
                idx === showGif && "bg-[#FFFFFF]"
              }`}
            >
              <img src={checkMark} alt="check-mark" className="mt-1" />
              <div className="w-full text-[#082247] text-base text-left font-light leading-[25.6px]">
                {point.text}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="w-[382px] max-h-[250px] md:min-w-[44%] md:max-h-[100%] flex flex-col items-center md:justify-center justify-start">
        <img
          className="max-h-[250px] md:w-full md:max-h-full border rounded-[10px]"
          src={points[showGif].gifSrc}
          alt="Demo GIF"
        />
      </div>
    </div>
  );
};

const dbtFeatureColumns = [
  {
    id: "col1",
    title: <>Generate {DBT_NAME} models and translate SQL</>,
    points: [
      {
        text: <>Generate {DBT_NAME} Models from SQL or source files</>,
        gifSrc: demo_1_1,
      },
      {
        text: <>Update {DBT_NAME} model in natural language</>,
        gifSrc: demo_1_2,
      },
      {
        text: "Translate queries in one SQL dialect to another.",
        gifSrc: demo_1_2,
      },
    ],
    reversed: false,
  },
  {
    id: "col2",
    title: <>Document tables, columns, and {DBT_NAME} models</>,
    points: [
      {
        text: (
          <>Generate descriptions for tables, columns, and {DBT_NAME} models</>
        ),
        gifSrc: demo_2,
      },
      {
        text: "Support for different personas and languages",
        gifSrc: demo_2,
      },
      {
        text: "Enable AI-enhanced collaboration for documentation",
        gifSrc: demo_2,
      },
    ],
    reversed: true,
  },
  {
    id: "col3",
    title: "Generate tests, column lineage, and query explanations",
    points: [
      { text: "Create and update tests seamlessly", gifSrc: demo_3_1 },
      {
        text: "Get query explanations and visualization",
        gifSrc: demo_3_2,
      },
      {
        text: "Impact analysis with real time column lineage",
        gifSrc: demo_3_3,
      },
    ],
    reversed: false,
  },
  {
    id: "col4",
    title: "Advise on best practices and organizational governance",
    points: [
      { text: "Define custom guidelines in SaaS", gifSrc: demo_4 },
      {
        text: "Get assistance and validations in IDE, Git, CI/CD",
        gifSrc: demo_4,
      },
      {
        text: "Smart complete jinja, SQL code in IDE",
        gifSrc: demo_4,
      },
    ],
    reversed: true,
    gifSrc: demo_1_1,
  },
];

const DBTColumns = () => {
  const handleGithubLinkClick = () => {
    if (window.gtag) {
      window.gtag("config", "G-B7LCCXF90E");
      window.gtag("event", "conversion", {
        send_to: "AW-10951864387/Gj_uCJzPgc8YEMPgoOYo",
      });
    }
  };
  return (
    <div className="bg-[#F5F7F9] md:columns md:pb-[100px] pb-[70px]">
      <div className="text-[#082247] font-lexend text-4xl font-semibold text-center mt-[100px] md:mb-[30px]">
        AI teammates for Specialized Work
      </div>
      {dbtFeatureColumns.map((feature, index) => (
        <DBTFeaturesColumns key={index} {...feature} />
      ))}
    </div>
  );
};

export default DBTColumns;
